// extracted by mini-css-extract-plugin
export var avatarContainer = "_eh-0";
export var avatarTypingWave = "_eh-i";
export var gray = "_eh-f";
export var green = "_eh-c";
export var icon = "_eh-9";
export var image = "_eh-1";
export var lg = "_eh-6";
export var md = "_eh-5";
export var presenceDot = "_eh-b";
export var red = "_eh-d";
export var sm = "_eh-4";
export var status = "_eh-a";
export var typingDot = "_eh-h";
export var typingPill = "_eh-g";
export var xl = "_eh-7";
export var xs = "_eh-3";
export var xxl = "_eh-8";
export var xxs = "_eh-2";
export var yellow = "_eh-e";